import { useLocation } from 'react-router-dom';
import { MONTHS } from '@/shared/utils/dateHelpers';
import { S } from '@/shared/constants/styles';
import { NAV_ITEMS } from './Sidebar';
import { usePeriod } from '@/app/providers/PeriodProvider';
import { useSettingsContext } from '@/app/providers/SettingsProvider';

export default function AppHeader({ setSideOpen, sideOpen }) {
  const { t } = useSettingsContext();
  const { selMonth, setSelMonth, selYear, setSelYear } = usePeriod();
  const location = useLocation();
  const id = location.pathname.replace(/^\/+/, '').split('/')[0] || 'dashboard';
  const label = ((NAV_ITEMS.find((n) => n.id === id)) || {}).label || '';

  return (
    <header style={{ position: 'sticky', top: 0, zIndex: 20, background: t.headerBg, backdropFilter: 'blur(12px)', borderBottom: '1px solid ' + t.cardBorder, padding: '10px 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <button className="hamburger-btn" onClick={() => setSideOpen(true)} aria-label="Open menu" aria-expanded={sideOpen} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: t.textMuted, padding: 4, lineHeight: 1, minHeight: 44, minWidth: 44, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{'\u2630'}</button>
        <h1 style={{ fontSize: 18, fontWeight: 800, color: t.text, margin: 0 }}>{String(label)}</h1>
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <select value={selMonth} onChange={(e) => setSelMonth(Number(e.target.value))} style={{ ...S.select, width: 'auto', fontSize: 12, padding: '7px 10px' }}>{MONTHS.map((m, i) => <option key={i} value={i}>{m}</option>)}</select>
        <input type="number" value={selYear} onChange={(e) => setSelYear(Number(e.target.value))} style={{ ...S.input, width: 68, fontSize: 12, padding: '7px 10px' }} />
      </div>
    </header>
  );
}
